module.exports = __webpack_public_path__ + "static/media/12.e07a174b.jpg";